import {
  defaultDonor,
  defaultSystemCode,
  defaultTrader,
  Donor,
  DonorFromJSON,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  Trader,
  TraderFromJSON
} from '@/api'

export interface BibliographySetDetailAutoOrder {
  id: number
  bibliographySetId: number
  orderBranchCode: SystemCode
  traderCode: Trader
  donorCode: Donor
  orderNumber: number
  buyDepartmentCode: SystemCode
  donatedNumber: number
  budgetYear: number
  budgetBranchCode: SystemCode
  budgetDepartmentCode: SystemCode
  budgetItem: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  acceptType: SystemCode
  storeType: SystemCode
  shelfType: SystemCode
  equipType: SystemCode
  mark: string
  ndc: string
  book: string
  sub: string
  storingLimitCode: SystemCode
  revision: number
}

export const defaultBibliographySetDetailAutoOrder = (): BibliographySetDetailAutoOrder => ({
  id: 0,
  bibliographySetId: 0,
  orderBranchCode: defaultSystemCode(),
  traderCode: defaultTrader(),
  donorCode: defaultDonor(),
  orderNumber: 0,
  buyDepartmentCode: defaultSystemCode(),
  donatedNumber: 0,
  budgetYear: 0,
  budgetBranchCode: defaultSystemCode(),
  budgetDepartmentCode: defaultSystemCode(),
  budgetItem: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  acceptType: defaultSystemCode(),
  storeType: defaultSystemCode(),
  shelfType: defaultSystemCode(),
  equipType: defaultSystemCode(),
  mark: '',
  ndc: '',
  book: '',
  sub: '',
  storingLimitCode: defaultSystemCode(),
  revision: 0
})

export function BibliographySetDetailAutoOrderFromJSON(
  json: any
): BibliographySetDetailAutoOrder {
  return {
    id: exists(json, 'id') ? json.id : 0,
    bibliographySetId: exists(json, 'bibliography_set_id')
      ? json.bibliography_set_id
      : 0,
    orderBranchCode: exists(json, 'order_branch_code')
      ? SystemCodeFromJSON(json.order_branch_code)
      : defaultSystemCode(),
    traderCode: exists(json, 'trader_code')
      ? TraderFromJSON(json.trader_code)
      : defaultTrader(),
    donorCode: exists(json, 'donor_code')
      ? DonorFromJSON(json.donor_code)
      : defaultDonor(),
    orderNumber: exists(json, 'order_number') ? json.order_number : 0,
    buyDepartmentCode: exists(json, 'buy_department_code')
      ? SystemCodeFromJSON(json.buy_department_code)
      : defaultSystemCode(),
    donatedNumber: exists(json, 'donated_number') ? json.donated_number : 0,
    budgetYear: exists(json, 'budget_year') ? json.budget_year : 0,
    budgetBranchCode: exists(json, 'budget_branch_code')
      ? SystemCodeFromJSON(json.budget_branch_code)
      : defaultSystemCode(),
    budgetDepartmentCode: exists(json, 'budget_department_code')
      ? SystemCodeFromJSON(json.budget_department_code)
      : defaultSystemCode(),
    budgetItem: exists(json, 'budget_item')
      ? SystemCodeFromJSON(json.budget_item)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    storeType: exists(json, 'store_type')
      ? SystemCodeFromJSON(json.store_type)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : '',
    storingLimitCode: exists(json, 'storing_limit_code')
      ? SystemCodeFromJSON(json.storing_limit_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
